import { Collapsible } from '../interfaces';
import { UncontrolledTransaction } from './uncontrolled-transaction';

export class TransactionComparability implements Collapsible {
  transactionComparabilityId: number;
  uncontrolledTransaction: UncontrolledTransaction;
  economicAnalysisSimilarity: number;
  functionalAnalysisSimilarity: number;
  contractualTermsSimilarity: number;
  comparabilityEvaluation: string;
  status: number;
  justifyAction: string;
  collapsed: boolean;
}
